import { render, staticRenderFns } from "./h-crud.vue?vue&type=template&id=973ebc26&"
import script from "./h-crud.vue?vue&type=script&lang=js&"
export * from "./h-crud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports